// The ten llama colours, in the order of `ColorPalette.LLAMA_HUES` in the game.
// A llama's `hue` from the room is an index into this list. Change both together.

export const HUES: readonly string[] = [
  '#ff3f8c', // HOT_PINK
  '#ff6666', // BUTTON_RED_HIGHLIGHT
  '#da863e', // MEDIUM_ORANGE
  '#e8c170', // GOLDEN_YELLOW
  '#c7ff33', // NEON_YELLOW
  '#a8ca58', // LIME_GREEN
  '#a4dddb', // PALE_CYAN
  '#73bed3', // LIGHT_BLUE
  '#4f8fba', // MEDIUM_BLUE
  '#c65197', // BRIGHT_MAGENTA
];

// A llama with no colour yet (still connecting) draws in the game's grey.
export const NO_HUE = '#908ca4';

export const hueColor = (hue: number | null): string =>
  hue === null ? NO_HUE : (HUES[hue] ?? NO_HUE);
